import { useEffect, useState } from "react";
import "./NewVendor.css";
import Stepper from "../../components/Stepper";
import { Button, Card, Form, Alert, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import VendorFormStep1 from "./VendorFormStep1";
import VendorFormStep2 from "./VendorFormStep2";
import VendorFormStep3 from "./VendorFormStep3";
import {
  IconArrowNarrowLeftDashed,
  IconArrowNarrowRightDashed,
} from "@tabler/icons-react";
import usePostRequest from "../../hooks/usePostRequest";
import { API_ENDPOINTS } from "../../constant/_constant";
import { useParams } from "react-router-dom";
import { useForm, FormProvider } from "react-hook-form";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import Notes from "../../components/Notes/Notes";
import { useCallback } from "react";
import useIdleLogout from "../../hooks/useIdleLogout";

const steps = ["General", "Billing", "Attachments", "Notes"];

const generateUniqueId = () => {
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  // Generate 8 random characters
  let result = "";
  for (let i = 0; i < 8; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    result += characters.charAt(randomIndex);
  }

  const timestamp = Date.now().toString();
  const uniqueId = result + timestamp.slice(-4);
  return uniqueId;
};

const validationSchema = Yup.object().shape({
  display_name: Yup.string().required("Company Name is required"),
  // company_name: Yup.string()
  //   .transform((value) => (value === "" ? null : value))
  //   .nullable()
  //   .optional(),
  // title: Yup.string()
  //   .transform((value) => (value === "" ? null : value))
  //   .nullable()
  //   .optional(),
  first_name: Yup.string()
    .transform((value) => (value === "" ? null : value))
    .nullable()
    .optional(),
  last_name: Yup.string()
    .transform((value) => (value === "" ? null : value))
    .nullable()
    .optional(),
  email: Yup.string()
    .transform((value) => (value === "" ? null : value))
    .nullable()
    .email("Invalid email format")
    .optional(),
  billing_email: Yup.string()
    .transform((value) => (value === "" ? null : value))
    .nullable()
    .email("Invalid email format")
    .optional(),
  billing_name: Yup.string()
    .transform((value) => (value === "" ? null : value))
    .nullable()
    .optional(),
  billing_phone: Yup.string()
    .transform((value) => (value === "" ? null : value))
    .nullable()
    .min(10, "Phone number must be at least 10 digits")
    .optional(),
  // suffix: Yup.string()
  //   .transform((value) => (value === "" ? null : value))
  //   .nullable()
  //   .optional(),
  middle_name: Yup.string()
    .transform((value) => (value === "" ? null : value))
    .nullable()
    .optional(),
  phone_number: Yup.string()
    .transform((value) => (value === "" ? null : value))
    .nullable()
    .min(10, "Phone number must be at least 10 digits")
    .optional(),
  // Step 2
  address_1: Yup.string()
    .transform((value) => (value === "" ? null : value))
    .nullable()
    .optional(),
  Address: Yup.string()
    .transform((value) => (value === "" ? null : value))
    .nullable()
    .optional(),
  city: Yup.string()
    .transform((value) => (value === "" ? null : value))
    .nullable()
    .optional(),
  state: Yup.string()
    .transform((value) => (value === "" ? null : value))
    .nullable()
    .optional(),
  zip_code: Yup.string()
    .transform((value) => (value === "" ? null : value))
    .nullable()
    .min(5, "minimum 5 digits")
    .max(10, "maximum 10 digits")
    .optional(),
  country: Yup.string()
    .transform((value) => (value === "" ? null : value))
    .nullable()
    .optional(),
  // Step 3
  // print_check_name: Yup.string()
  //   .transform((value) => (value === "" ? null : value))
  //   .nullable()
  //   .optional(),
  tax_identifier: Yup.string()
    .transform((value) => (value === "" ? null : value))
    .nullable()
    .optional(),
  website: Yup.string()
    .transform((value) => (value === "" ? null : value))
    .nullable()
    .url("Please enter a valid URL")
    .optional(),
  // fax: Yup.string()
  //   .transform((value) => (value === "" ? null : value))
  //   .nullable()
  //   .min(5, "at least 5 digits")
  //   .optional(),
  // alternate_phone: Yup.string()
  //   .transform((value) => (value === "" ? null : value))
  //   .nullable()
  //   .min(10, "Alternative Phone number must be at least 10 digits")
  //   .optional(),

  // account_no: Yup.string()
  //   .transform((value) => (value === "" ? null : value))
  //   .nullable()
  //   .matches(/^\d+$/, "Account Number must be numeric")
  //   .min(6, "Account Number must be at least 6 digits")
  //   .optional(),
  // terms: Yup.string()
  //   .transform((value) => (value === "" ? null : value))
  //   .nullable()
  //   .optional(),
  // balance: Yup.string()
  //   .transform((value) => (value === "" ? null : value))
  //   .nullable()
  //   .optional(),
  // vendor_1099: Yup.boolean().optional(),
});

const NewVendor = () => {
  const navigate = useNavigate();

  const { auto_id } = useParams();
  const [isEditing, setIsEditing] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const [validated, setValidated] = useState(false);
  const [formData, setFormData] = useState({
    // company_name: "",
    // notes: [],
    display_name: "",
    // title: "",
    first_name: "",
    middle_name: "",
    last_name: "",
    // suffix: "",
    email: "",
    billing_name: "",
    billing_email: "",
    // balance: "",
    phone_number: "",
    billing_phone: "",
    // alternate_phone: "",
    // fax: null,
    // other: "",
    website: null,
    address_1: "",
    address_2: "",
    city: "",
    state: "",
    zip_code: "",
    country: "",

    // terms: "",
    // account_no: "",
    // vendor_1099: false,
    // print_check_name: "",
    // tax_identifier: "",
    Addid: null,
  });
  const [formId, setFormId] = useState(null);

  console.log("formData", formData);

  const [errorsVisible, setErrorsVisible] = useState(false);
  const [vendorDataFetched, setVendorDataFetched] = useState(false);

  const { isLoading, postData } = usePostRequest(
    API_ENDPOINTS.ADD_UPDATE_VENDORS
  );

  const { isLoadingquickbook, postData: WihtouthQuickBook } = usePostRequest(
    API_ENDPOINTS.UPDATE_VENDORS_WITHOUT_QUICKBOOK
  );

  const { data: vendor, postData: fetchVendor } = usePostRequest(
    API_ENDPOINTS.GET_SINGLE_VENDOR
  );

  const { isLoading: notesLoading, postData: createNotes } = usePostRequest(
    API_ENDPOINTS.CREATE_NOTES
  );

  const methods = useForm({
    resolver: yupResolver(validationSchema),
    mode: "onChange",
    defaultValues: formData,
  });

  const {
    handleSubmit,
    control,
    watch,
    formState: { errors },
    setValue,
    trigger,
    reset,
  } = methods;

  const formValues = watch();

  const currentData = methods.getValues();

  useIdleLogout();

  useEffect(() => {
    Object.keys(formData).forEach((key) => setValue(key, formData[key]));
  }, [formData, setValue]);

  const handleFormChange = (e, val) => {
    // console.log("handle", val);

    const { name, value, checked, type } = e.target;
    if (type === "checkbox") {
      setFormData((prev) => ({ ...prev, [name]: checked }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleStepChange = useCallback(
    async (type) => {
      let isValid = true;

      if (type === "next") {
        const currentData = methods.getValues();
        console.log(currentData);

        if (currentStep === 1) {
          isValid = await trigger([
            "display_name",
            // "title",
            "first_name",
            // "suffix",
            "middle_name",
            "last_name",
            "email",
            "phone_number",
            // "alternate_phone",
            // "mobile_number",
            // "print_check_name",
            "website",
            // "fax",
          ]);
        } else if (currentStep === 2) {
          isValid = await trigger([
            "address_1",
            "address_2",
            "city",
            "state",
            "zip_code",
            "country",
          ]);
        } else if (currentStep === 3) {
          isValid = await trigger([
            // Add fields when needed
          ]);
        } else if (currentStep === 4) {
          isValid = await trigger(["notes"]);
        }

        // Prevent going beyond the last step
        if (isValid && currentStep < steps.length) {
          setErrorsVisible(false);
          setCurrentStep((prev) => prev + 1);
        } else if (!isValid) {
          setErrorsVisible(true);
        }
      } else if (type === "prev") {
        // Prevent going below the first step
        if (currentStep > 1) {
          setErrorsVisible(false);
          setCurrentStep((prev) => prev - 1);
        }
      }
    },
    [currentStep, trigger, setCurrentStep, setErrorsVisible]
  );

//   useEffect(() => {
//     const handleKeyDown = (event) => {
//       if (event.repeat) return; // Prevent repeat spam
//       if (event.key === "ArrowRight") {
//         handleStepChange("next");
//       } else if (event.key === "ArrowLeft") {
//         handleStepChange("prev");
//       }
//     };

//     document.addEventListener("keydown", handleKeyDown);
//     return () => document.removeEventListener("keydown", handleKeyDown);
//   }, [handleStepChange]);

  const onErrorQuickBook = (error) => {
    toast.error(error?.message);
  };

  const onError = (error) => {
    toast.error(error?.message);
  };

  const onSubmit = async (data) => {
    console.log("data", data);
    const isValid = await trigger();
    if (isValid) {
      const payload = {
        auto_id: auto_id || null,
        vendor_type: data?.vendor_type,
        display_name: data?.display_name,
        attachment_id: formId,
        first_name: data?.first_name || null,
        last_name: data?.last_name || null,
        address: data?.Address || null,
        primary_email: data.email ? { Address: data?.email } : null,
        primary_phone: data.phone_number
          ? { FreeFormNumber: data?.phone_number }
          : null,
        billing_name: data?.billing_name || null,
        billing_email: data?.billing_email || null,
        billing_phone: data?.billing_phone || null,
        billing_address:
          data?.city ||
            data?.address_1 ||
            data.address_2 ||
            data.country ||
            data.zip_code ||
            data.state
            ? {
              Id: formData?.Addid,
              City: data.city || null,
              Line1: data.address_1 || null,
              Line2: data.address_2 || null,
              Country: data.country || null,
              PostalCode: data.zip_code || null,
              CountrySubDivisionCode: data.state || null,
            }
            : null,
        web_addr: data.website ? { URI: data.website } : null,
      };

      // const payload = {
      //   auto_id: auto_id || null,
      //   display_name: data?.display_name,
      //   attachment_id: formId,
      //   first_name: data?.first_name || null,
      //   last_name: data?.last_name || null,
      //   address: data?.Address || null,
      //   primary_email: data?.email
      //     ? JSON.stringify({ Address: data?.email })
      //     : null,
      //   primary_phone: data.phone_number
      //     ? JSON.stringify({ FreeFormNumber: data?.phone_number })
      //     : null,
      //   billing_name: data?.billing_name || null,
      //   billing_email: data?.billing_email || null,
      //   billing_phone: data?.billing_phone || null,
      //   billing_address:
      //     data?.city ||
      //     data?.address_1 ||
      //     data.address_2 ||
      //     data.country ||
      //     data.zip_code ||
      //     data.state
      //       ? JSON.stringify({
      //           Id: formData?.Addid,
      //           City: data.city ? data.city : null,
      //           Line1: data.address_1 ? data.address_1 : null,
      //           Line2: data.address_2 ? data.address_2 : null,
      //           Country: data.country ? data.country : null,
      //           PostalCode: data.zip_code ? data.zip_code : null,
      //           CountrySubDivisionCode: data.state ? data.state : null,
      //         })
      //       : null,
      //   web_addr: data.website
      //     ? JSON.stringify({ URI: data.website ? data.website : null })
      //     : null,
      // };

      const onSuccess = (response) => {
        // console.log("response", response);
        const notesPayload = {
          module_id: response?.auto_id,
          module_type: "VENDOR",
          notes: data.notes,
        };
        if (
          Array.isArray(notesPayload.notes) &&
          notesPayload.notes.length > 0
        ) {
          createNotes(notesPayload);
        }
        // console.log("notesPayload", notesPayload);
        toast.success(response?.message);
        navigate("/vendor");
      };

      const onSuccessQuickBook = (response) => {
        console.log("response quick", response);
        const notesPayload = {
          module_id: response?.auto_id,
          module_type: "VENDOR",
          notes: data.notes,
        };
        // console.log("notesPayload");
        if (
          Array.isArray(notesPayload.notes) &&
          notesPayload.notes.length > 0
        ) {
          createNotes(notesPayload);
        }
        // createNotes(notesPayload);
        toast.success(response?.message);
        navigate("/vendor");
      };

      if (vendor && vendor?.data?.quickbook_id == 0) {
        WihtouthQuickBook(
          JSON.stringify(payload),
          onSuccessQuickBook,
          onErrorQuickBook
        );
      } else {
        postData(JSON.stringify(payload), onSuccess, onError);
      }
    } else {
      console.log("Validation errors:", errors);
    }
  };

  useEffect(() => {
    if (auto_id && !vendorDataFetched) {
      fetchVendor({ auto_id });
      setVendorDataFetched(true);
      setIsEditing(true);
    }
  }, [auto_id, vendorDataFetched, fetchVendor]);

  const { data: notesData, postData: fetchNotes } = usePostRequest(
    API_ENDPOINTS.GET_NOTES
  );

  const transformData = (resData) => {
    return {
      notes: resData.map((section) => ({
        section: section.name,
        custom_id: section.custom_id,
        notesdata: section.notes.map((noteItem) => ({
          note: noteItem.note,
          user: noteItem.User.username,
          updateAt: noteItem.updated_at,
          custom_id: noteItem.custom_id || undefined,
        })),
      })),
    };
  };

  const onSingleNotesSuccess = (res) => {
    if (res?.data) {
      const transformedData = transformData(res.data);
      setValue("notes", transformedData.notes);
    }
  };

  useEffect(() => {
    if (auto_id && !vendor) {
      fetchNotes(
        {
          module_id: auto_id,
          module_type: "VENDOR",
        },
        onSingleNotesSuccess
      );
    }
  }, [auto_id, fetchNotes]);

  const safeParse = (value) => {
    try {
      return typeof value === "string" ? JSON.parse(value) : value;
    } catch (e) {
      return null;
    }
  };

  useEffect(() => {
    if (vendor) {
      console.log("vendor data =>", vendor?.data);
      if (vendor?.data?.attachment_id) {
        setFormId(vendor?.data?.attachment_id);
      }

      // setFormData((prevData) => ({
      //   ...prevData,
      //   display_name: vendor?.data?.display_name || null,
      //   first_name: vendor?.data?.first_name || null,
      //   last_name: vendor?.data?.last_name || null,
      //   attachment_id: vendor?.data?.attachment_id || formId,

      //   email: vendor?.data?.VendorContact?.primary_email
      //     ? vendor.data.VendorContact.primary_email?.Address
      //     : null,

      //   phone_number: vendor?.data?.VendorContact?.primary_phone
      //     ? vendor.data.VendorContact.primary_phone?.FreeFormNumber
      //     : null,

      //   website: vendor?.data?.VendorContact?.web_addr
      //     ? vendor?.data?.VendorContact?.web_addr.URI
      //     : null,

      //   Address: vendor?.data?.VendorContact?.address || null,

      //   address_1: vendor?.data?.VendorContact?.billing_address
      //     ? vendor?.data?.VendorContact?.billing_address.Line1
      //     : null,
      //   address_2: vendor?.data?.VendorContact?.billing_address
      //     ? vendor?.data?.VendorContact?.billing_address.Line2
      //     : null,
      //   city: vendor?.data?.VendorContact?.billing_address
      //     ? vendor?.data?.VendorContact?.billing_address.City
      //     : null,
      //   state: vendor?.data?.VendorContact?.billing_address
      //     ? vendor?.data?.VendorContact?.billing_address.CountrySubDivisionCode
      //     : null,
      //   zip_code: vendor?.data?.VendorContact?.billing_address
      //     ? vendor?.data?.VendorContact?.billing_address.PostalCode
      //     : null,
      //   country: vendor?.data?.VendorContact?.billing_address
      //     ? vendor?.data?.VendorContact?.billing_address.Country
      //     : null,
      //   Addid: vendor?.data?.VendorContact?.billing_address
      //     ? vendor?.data?.VendorContact?.billing_address.Id
      //     : null,

      //   billing_email: vendor?.data?.VendorContact?.billing_email || null,
      //   billing_name: vendor?.data?.VendorContact?.billing_name || null,
      //   billing_phone: vendor?.data?.VendorContact?.billing_phone || null,
      // }));
      // setValue("Address", vendor?.data?.VendorContact?.address || null);

      // setValue(
      //   "billing_phone",
      //   vendor?.data?.VendorContact?.billing_phone || null
      // );
      // setValue(
      //   "billing_email",
      //   vendor?.data?.VendorContact?.billing_email || null
      // );
      // setValue(
      //   "billing_name",
      //   vendor?.data?.VendorContact?.billing_name || null
      // );

      setValue("vendor_code", vendor?.data?.vendor_code || null);

      const cleanPhoneNumber = (phone) => {
        if (!phone) return null;
        const digits = phone.replace(/\D/g, "");
        return digits ? "+" + digits : null;
      };

      setFormData((prevData) => ({
        ...prevData,
        display_name: vendor.data.display_name,
        first_name: vendor.data.first_name,
        last_name: vendor.data.last_name,
        attachment_id: vendor.data.attachment_id || formId,

        email: vendor.data.VendorContact?.primary_email?.Address || null,
        // phone_number:
        //   vendor.data.VendorContact?.primary_phone?.FreeFormNumber || null,
        phone_number: cleanPhoneNumber(
          vendor.data.VendorContact?.primary_phone?.FreeFormNumber
        ),
        website: vendor.data.VendorContact?.web_addr?.URI || null,
        Address: vendor.data.VendorContact?.address || null,

        address_1: vendor.data.VendorContact?.billing_address?.Line1 || null,
        address_2: vendor.data.VendorContact?.billing_address?.Line2 || null,
        city: vendor.data.VendorContact?.billing_address?.City || null,
        state:
          vendor.data.VendorContact?.billing_address?.CountrySubDivisionCode ||
          null,
        zip_code:
          vendor.data.VendorContact?.billing_address?.PostalCode || null,
        country: vendor.data.VendorContact?.billing_address?.Country || null,
        Addid: vendor.data.VendorContact?.billing_address?.Id || null,

        billing_email: vendor.data.VendorContact?.billing_email || null,
        billing_name: vendor.data.VendorContact?.billing_name || null,
        // billing_phone: vendor.data.VendorContact?.billing_phone || null,
        billing_phone: cleanPhoneNumber(
          vendor.data.VendorContact?.billing_phone
        ),
      }));

      // Set form values individually
      setValue("vendor_type", vendor.data.vendor_type || "");
      setValue("Address", vendor.data.VendorContact?.address || null);
      setValue(
        "billing_phone",
        vendor.data.VendorContact?.billing_phone || null
      );
      setValue(
        "billing_email",
        vendor.data.VendorContact?.billing_email || null
      );
      setValue("billing_name", vendor.data.VendorContact?.billing_name || null);

      // setFormData((prevData) => {
      //   const contact = vendor?.data?.VendorContact || {};

      //   const parsedEmail = safeParse(contact.primary_email);
      //   const parsedPhone = safeParse(contact.primary_phone);
      //   const parsedWeb = safeParse(contact.web_addr);
      //   const parsedBilling = safeParse(contact.billing_address);

      //   return {
      //     ...prevData,
      //     display_name: vendor?.data?.display_name || null,
      //     first_name: vendor?.data?.first_name || null,
      //     last_name: vendor?.data?.last_name || null,
      //     attachment_id: vendor?.data?.attachment_id || formId,

      //     email: parsedEmail?.Address || null,
      //     phone_number: parsedPhone?.FreeFormNumber || null,
      //     website: parsedWeb?.URI || null,

      //     Address: contact.address || null,

      //     address_1: parsedBilling?.Line1 || null,
      //     address_2: parsedBilling?.Line2 || null,
      //     city: parsedBilling?.City || null,
      //     state: parsedBilling?.CountrySubDivisionCode || null,
      //     zip_code: parsedBilling?.PostalCode || null,
      //     country: parsedBilling?.Country || null,
      //     Addid: parsedBilling?.Id || null,

      //     billing_email: contact.billing_email || null,
      //     billing_name: contact.billing_name || null,
      //     billing_phone: contact.billing_phone || null,
      //   };
      // });

      Object.keys(vendor).forEach((key) => {
        setValue(key, vendor[key] || "");
      });
    }
  }, [vendor, setValue]);

  useEffect(() => {
    const newFormId = generateUniqueId();
    setFormId(newFormId);
    reset();
  }, []);

  return (
    <>
      <div className="page-header d-none d-sm-block ">
        <div className=" d-flex justify-content-between  align-items-center">
          <div>
            <h2 className="page-title">
              {auto_id ? "Update Vendor" : "Create Vendor"}
            </h2>
          </div>
        </div>
      </div>

      <Card className="pt-3 pb-4 mt-5 mt-sm-0">
        <Card.Body>
          {/* <div className="page-header text-center">
          <h2 className="page-title justify-content-center">
            {!auto_id ? "Create Account" : "Edit Your Details"}{" "}
          </h2>
        </div> */}
          <Stepper steps={steps} currentStep={currentStep} />

          <FormProvider {...methods}>
            <Form
              noValidate
              validated={validated}
              onSubmit={handleSubmit(onSubmit)}
            >
              {currentStep === 1 && (
                <VendorFormStep1
                  isEditing={isEditing}
                  formData={formData}
                  handleFormChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      [e.target.name]: e.target.value,
                    }))
                  }
                  control={control}
                  errors={errors}
                />
              )}
              {currentStep === 2 && (
                <VendorFormStep2
                  isEditing={isEditing}
                  formData={formData}
                  handleFormChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      [e.target.name]: e.target.value,
                    }))
                  }
                  control={control}
                  errors={errors}
                />
              )}
              {currentStep === 3 && (
                <VendorFormStep3
                  attachmnetid={formId}
                  isEditing={isEditing}
                  formData={formData}
                  handleFormChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      [e.target.name]: e.target.value,
                    }))
                  }
                  control={control}
                  errors={errors}
                />
              )}

              {currentStep === 4 && (
                <Notes module_type={"VENDOR"} module_id={auto_id} />
              )}

              {/* {errorsVisible && Object.keys(errors).length > 0 && (
              <Alert variant="danger" className="">
                Please Fill the Detail Highligted field .
              </Alert>
            )} */}

              <div className="d-flex justify-content-center gap-3 mt-4">
                {currentStep > 1 && (
                  <Button
                    variant="outline-secondary"
                    onClick={() => handleStepChange("prev")}
                  >
                    <IconArrowNarrowLeftDashed /> Back
                  </Button>
                )}
                {currentStep < 4 && (
                  <Button
                    variant="warning"
                    onClick={() => handleStepChange("next")}
                  >
                    Next <IconArrowNarrowRightDashed />
                  </Button>
                )}
                {auto_id
                  ? currentStep < steps.length && (
                    <div className="d-flex">
                      <Button variant="success" type="submit">
                        {isLoading ? (
                          <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                          />
                        ) : (
                          "Update"
                        )}
                      </Button>
                    </div>
                  )
                  : null}
                {currentStep === 4 && (
                  <Button variant="warning" type="submit" disabled={isLoading}>
                    Submit
                  </Button>
                )}
              </div>
            </Form>
          </FormProvider>
        </Card.Body>
      </Card>
    </>
  );
};

export default NewVendor;
